module.exports = __webpack_public_path__ + "static/media/ONG.7585f730.svg";